
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"12","viewBox":"0 0 16 12","fill":"none","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.75 1.25h6.5M.75 6.25h10.5M.75 11.25h14.5"}})])
          )
        }
      }
    